<template>
  <tk-container center style="background: #fff;">
    <div v-show="true" id="down-qr-code" class="box">
      <tk-flex center middle :gutter="15" class="tkFlex">
        <!-- <tk-qrcode :value="_val" style="width: 138px; height: 138px;" :size="200"></tk-qrcode> -->
        <vue-qr :text="_val" :logoSrc="logo" style="width: 210px; height: 210px;" class="m-r-10"></vue-qr>
        <span
          style="width: 0px;
                   height: 170px;
                   border-left: 1px  solid #F75F36;"
        ></span>
        <div style="width:450px;height:175px;margin-bottom:10px">
          <tk-flex column :gutter="15">
            <div
              style="
                     font-style: normal;
                     font-weight: bold;
                     font-size: 22px;
                     line-height: 32px;
                     text-align:left "
              class="title"
              v-html="title"
            ></div>
            <div
              style="
                     font-size: 16px;
                     line-height: 22px;
                     text-align:left"
              class="abstract"
            >{{abstract}}</div>
          </tk-flex>
        </div>
      </tk-flex>
    </div>
  </tk-container>
</template>

<script>
import logo from '@/assets/image/logo.png'
import VueQr from 'vue-qr'
export default {
  components: {
    VueQr
  },
  computed: {
    _val () {
      return `https://publicity.mokekeji.com/jiacai/?objectId=${this.$route.query.objectId}`
    }
  },
  data () {
    return {
      logo: logo,
      title: '',
      abstract: ''
    }
  },
  mounted () {
    // console.log('success')
    // console.log(this.$route)
    this.getData()
  },
  methods: {
    async getData () {
      let { data: res } = await this.$tkParse.get(`https://cloud.jiacai.mokekeji.com/classes/Docs/${this.$route.query.objectId}`).catch(e => {
        console.log(e)
        alert('图片下载失败,请重试')
      })
      this.title = res.theme.replace(/[\n\r]/g, '<br/>')
      this.abstract = res.abstract
    },
    async downLoad () {
      // let tag = document.createElement('a')
      // tag.setAttribute('download', this.title)
      // let image = new Image()
      // image.width = 300
      // image.height = 300
      // image.src = dataUrl
      // image.crossOrigin = '*'
      // image.onload = () => {
      //   tag.href = dataUrl
      //   tag.click()
      // this.vm.$notification['success']({
      //   message: '下载完成',
      //   description: '下载成功'
      // })
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  overflow: hidden;
text-overflow: ellipsis;
display:-webkit-box; //弹性伸缩盒子显示。
-webkit-box-orient:vertical; //设置子元素排列方式--从上到下垂直排列
-webkit-line-clamp:3; //显示的行数
  color: #f75f36;
}
.abstract {
  overflow: hidden;
text-overflow: ellipsis;
display:-webkit-box; //弹性伸缩盒子显示。
-webkit-box-orient:vertical; //设置子元素排列方式--从上到下垂直排列
-webkit-line-clamp:3; //显示的行数
  color: #8995ad;
}
.box {
  text-align: center;
  width:800px;
  height: 368px;
  background: url('../../../assets/image/background.png') no-repeat;
  background-size: 100% 100%;
  .tkFlex {
    height: 268px;
    margin-top: 55px
  }
}
</style>
